import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { CollaborationService } from './services/collaboration.service';
import { Location } from '@angular/common';
import { isEmpty } from 'lodash';
import { CollaborationComponent } from './pages/collaboration/collaboration.component';
import { NotificationSettingsPageComponent } from './components/notification-settings-page/notification-settings-page.component';
import { NoRequiredDateComponent } from './no-required-date/no-required-date.component';
@Component({
    selector: 'app-root-component',
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss',
    imports: [CollaborationComponent, NotificationSettingsPageComponent, NoRequiredDateComponent]
})
export class AppComponent implements OnInit {
  initialUrl!: string;
  isUserLoggedIn = false;
  showCollaborationPage = false;
  isRequiredDetailsNotPresent = false;
  constructor(
    private readonly collaborationService: CollaborationService,
    private readonly location: Location,
    private readonly activatedRoute: ActivatedRoute
  ) {
  }
  ngOnInit(): void {
    const location = window.location.href;
    this.showCollaborationPage = location.includes("spaceId");
    this.initialUrl = window.location.href || '/';
    let tokenFromUrl = location.includes("token=") ? location.split("token=")[1] : '';
    if (!tokenFromUrl) {
      tokenFromUrl = localStorage.getItem("tokenFromUrl") ?? '';
    }
    if (!tokenFromUrl) {
      this.isRequiredDetailsNotPresent = true;
    } else {
      this.collaborationService.token = tokenFromUrl;
      localStorage.setItem("tokenFromUrl", tokenFromUrl);
      this.isUserLoggedIn = true;
      this.collaborationService.userEmail = this.collaborationService.getEmail();
    }
    this.removeTokenFromUrl();
  }

  removeTokenFromUrl() {
    this.activatedRoute.queryParams.subscribe(params => {
      if (isEmpty(params)) {
        return;
      }
      const newParams: Params = { ...params };
      delete newParams['token'];
      const queryString = this.buildQueryString(newParams);
      const newUrl = `${this.location.path().split('?')[0]}${queryString}`;
      this.location.replaceState(newUrl);
    });
  }

  private buildQueryString(params: Params): string {
    const queryString = Object.keys(params)
      .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
      .join('&');

    return queryString ? `?${queryString}` : '';
  }
}